import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatError } from "../lib/api";
import { AuthShell, Field } from "./Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (e) {
      toast.error(formatError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Choose a new password." subtitle="Enter your reset token and new password.">
      <form onSubmit={submit}>
        <Field label="Reset token" value={token} onChange={(e) => setToken(e.target.value)} required data-testid="reset-token" placeholder="Paste token" />
        <Field label="New password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password" placeholder="Min 6 characters" />
        <button disabled={busy} data-testid="reset-submit" className="w-full mt-2 bg-[#D4AF37] text-black font-semibold rounded-full py-3.5 hover:bg-[#E5C158] active:scale-[0.98] transition-all disabled:opacity-60">
          {busy ? "Updating…" : "Update password"}
        </button>
      </form>
      <p className="text-center text-sm text-[#A19DB0] mt-5">
        <Link to="/login" className="text-[#D4AF37] font-medium" data-testid="back-login">Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
